import dayjs from "dayjs";
import "dayjs/locale/vi";
import weekday from "dayjs/plugin/weekday";
import isoWeek from "dayjs/plugin/isoWeek";
import customParseFormat from "dayjs/plugin/customParseFormat";
import utc from "dayjs/plugin/utc";
import isToday from "dayjs/plugin/isToday";
import localizedFormat from "dayjs/plugin/localizedFormat";
import duration from "dayjs/plugin/duration";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
dayjs.extend(duration);
dayjs.extend(localizedFormat);
dayjs.extend(weekday);
dayjs.extend(isoWeek);
dayjs.extend(customParseFormat);
dayjs.extend(utc);
dayjs.extend(isToday);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
export const LOCALE = {
  Mon: "Th2",
  Tue: "Th3",
  Wed: "Th4",
  Thu: "Th5",
  Fri: "Th6",
  Sat: "Th7",
  Sun: "CN",
};
export const LOCALE_SHORT = {
  Mon: "T2",
  Tue: "T3",
  Wed: "T4",
  Thu: "T5",
  Fri: "T6",
  Sat: "T7",
  Sun: "CN",
};

export const toUTCString = (date: any) => {
  return dayjs.utc(date.format("YYYY-MM-DD HH:mm:ss")).toISOString();
};

export default dayjs;
